const orderRoutes = [
  {
    path: "/expressList",
    name: "expressList",
    component: () => import("@/views/order/expressList.vue"),
    meta: {
      title: "快递订单",
      keepAlive: true,
    },
  },
  {
    path: "/runlegList",
    name: "runlegList",
    component: () => import("@/views/order/runlegList.vue"),
    meta: {
      title: "同城订单",
      keepAlive: true,
    },
  },
  {
    path: "/lightList",
    name: "lightList",
    component: () => import("@/views/order/lightList.vue"),
    meta: {
      title: "超轻订单",
      keepAlive: true,
    },
  },
  {
    path: "/weightList",
    name: "weightList",
    component: () => import("@/views/order/weightList.vue"),
    meta: {
      title: "补缴列表",
      keepAlive: true,
    },
  },
  {
    path: "/cashList",
    name: "cashList",
    component: () => import("@/views/order/cashList.vue"),
    meta: {
      title: "现结订单",
      keepAlive: true,
    },
  },
];

export default orderRoutes;
